// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';

type Props = {
    escalationMatrix: Object,
};

const EscalationMatrixAttributes = (props: Props) => {
    const { escalationMatrix } = props;

    const attributes = [
        {
            label: <FormattedMessage id="escalation-matrix-task-type" defaultMessage="Task Type" />,
            value: escalationMatrix.type.name,
        },
        {
            label: <FormattedMessage id="escalation-matrix-org-unit-name" defaultMessage="Organisational Unit Name" />,
            multiValue: escalationMatrix.org_unit.map((ou) => ({ value: ou.name })),
            separator: ', ',
        },
        {
            label: <FormattedMessage id="escalation-matrix-sequence" defaultMessage="Sequence" />,
            value: escalationMatrix.sequence,
        },
    ];

    return <Attributes attributes={attributes} />;
};

export default EscalationMatrixAttributes;
